import { FC, ReactElement } from 'react';

import { Loader } from '@pp/core/src/components/loader/index';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { useChartsDataFetcher } from '../../../../store/apiHooks/useChartsDataFetcher';
import { useGameDispatch } from '../../../../store/GameStore';
import { useHighflyerGameStateSlice } from '../../../../store/slices/highflyerGame/selectors';
import { highflyerGameStateActions } from '../../../../store/slices/highflyerGame/slice';
import { ErrorMessage } from '../../errorMessage/ErrorMessage';
import { ScrollableWrapper } from '../../scrollableWrapper/ScrollableWrapper';

import { ChartsLineView } from './chartsLine/ChartsLineView';
import { MultiplierAndPercentageView } from './chartsLine/MultiplierAndPercentageView';

import styles from './StatsCharts.module.css';

export interface ChartsValueDataTypes {
  multiplier: string;
  percentage: number;
}

export const StatsCharts: FC = () => {
  const dispatch = useGameDispatch();
  const chartsDataFetcher = useChartsDataFetcher(true);
  const isApiRejected = useHighflyerGameStateSlice.getIsApiRejected();
  const chartsData = useHighflyerGameStateSlice.chartsData()?.percentages;

  return (
    <ScrollableWrapper>
      {((): ReactElement => {
        if (!chartsData && isApiRejected) {
          return (
            <ErrorMessage
              title="HIGHFLYER_FAILED_TO_LOAD"
              message="HIGHFLYER_INTERNAL_ERROR"
              disabled={false}
              loading={false}
              onClick={(): void => {
                chartsDataFetcher();
                dispatch(highflyerGameStateActions.setErrorOccured());
              }}
            />
          );
        } else if (!chartsData && !isApiRejected) {
          return <Loader />;
        } else {
          return (
            <div className={styles.tableStats_charts_container}>
              {chartsData && (
                <>
                  {Object.values(chartsData).map((item) => (
                    <div key={item} className={styles.tableStats_charts_single_item}>
                      <MultiplierAndPercentageView data={item as unknown as ChartsValueDataTypes} />
                      <ChartsLineView data={item as unknown as ChartsValueDataTypes} />
                    </div>
                  ))}
                  <div className={styles.chartsText}>
                    *<L10nText tk="CRASH_500_ROUND_RESULT" />
                  </div>
                </>
              )}
            </div>
          );
        }
      })()}
    </ScrollableWrapper>
  );
};
